import { object, string } from 'yup'

import { SEARCH_NAME_FIELD } from './common/TemplateSearch/model'

export const getSearchSchema = () =>
  object().shape({ [SEARCH_NAME_FIELD]: string().optional() })
